import React from 'react';
import Button from '../../kingpin/atoms/Button';

const CloseButton = ({ onClick }: { onClick: () => void }) => (
  <Button onClick={onClick} type="Secondary" size="Small" icon="cross" />
);

export default CloseButton;
